/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetCatalog200ResponseCategoriesInnerProductsInnerType } from './GetCatalog200ResponseCategoriesInnerProductsInnerType';
import {
    GetCatalog200ResponseCategoriesInnerProductsInnerTypeFromJSON,
    GetCatalog200ResponseCategoriesInnerProductsInnerTypeFromJSONTyped,
    GetCatalog200ResponseCategoriesInnerProductsInnerTypeToJSON,
    GetCatalog200ResponseCategoriesInnerProductsInnerTypeToJSONTyped,
} from './GetCatalog200ResponseCategoriesInnerProductsInnerType';

/**
 * 
 * @export
 * @interface GetCatalog200ResponseCategoriesInnerProductsInner
 */
export interface GetCatalog200ResponseCategoriesInnerProductsInner {
    /**
     * 
     * @type {string}
     * @memberof GetCatalog200ResponseCategoriesInnerProductsInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetCatalog200ResponseCategoriesInnerProductsInner
     */
    catalogId: string;
    /**
     * 
     * @type {string}
     * @memberof GetCatalog200ResponseCategoriesInnerProductsInner
     */
    categoryId: string;
    /**
     * 
     * @type {number}
     * @memberof GetCatalog200ResponseCategoriesInnerProductsInner
     */
    position: number;
    /**
     * 
     * @type {number}
     * @memberof GetCatalog200ResponseCategoriesInnerProductsInner
     */
    price: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetCatalog200ResponseCategoriesInnerProductsInner
     */
    enabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCatalog200ResponseCategoriesInnerProductsInner
     */
    deleted: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetCatalog200ResponseCategoriesInnerProductsInner
     */
    organizationItemId: string;
    /**
     * 
     * @type {GetCatalog200ResponseCategoriesInnerProductsInnerType}
     * @memberof GetCatalog200ResponseCategoriesInnerProductsInner
     */
    type: GetCatalog200ResponseCategoriesInnerProductsInnerType;
    /**
     * 
     * @type {string}
     * @memberof GetCatalog200ResponseCategoriesInnerProductsInner
     */
    name: string;
}

/**
 * Check if a given object implements the GetCatalog200ResponseCategoriesInnerProductsInner interface.
 */
export function instanceOfGetCatalog200ResponseCategoriesInnerProductsInner(value: object): value is GetCatalog200ResponseCategoriesInnerProductsInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('catalogId' in value) || value['catalogId'] === undefined) return false;
    if (!('categoryId' in value) || value['categoryId'] === undefined) return false;
    if (!('position' in value) || value['position'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('deleted' in value) || value['deleted'] === undefined) return false;
    if (!('organizationItemId' in value) || value['organizationItemId'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function GetCatalog200ResponseCategoriesInnerProductsInnerFromJSON(json: any): GetCatalog200ResponseCategoriesInnerProductsInner {
    return GetCatalog200ResponseCategoriesInnerProductsInnerFromJSONTyped(json, false);
}

export function GetCatalog200ResponseCategoriesInnerProductsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCatalog200ResponseCategoriesInnerProductsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'catalogId': json['catalogId'],
        'categoryId': json['categoryId'],
        'position': json['position'],
        'price': json['price'],
        'enabled': json['enabled'],
        'deleted': json['deleted'],
        'organizationItemId': json['organizationItemId'],
        'type': GetCatalog200ResponseCategoriesInnerProductsInnerTypeFromJSON(json['type']),
        'name': json['name'],
    };
}

export function GetCatalog200ResponseCategoriesInnerProductsInnerToJSON(json: any): GetCatalog200ResponseCategoriesInnerProductsInner {
    return GetCatalog200ResponseCategoriesInnerProductsInnerToJSONTyped(json, false);
}

export function GetCatalog200ResponseCategoriesInnerProductsInnerToJSONTyped(value?: GetCatalog200ResponseCategoriesInnerProductsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'catalogId': value['catalogId'],
        'categoryId': value['categoryId'],
        'position': value['position'],
        'price': value['price'],
        'enabled': value['enabled'],
        'deleted': value['deleted'],
        'organizationItemId': value['organizationItemId'],
        'type': GetCatalog200ResponseCategoriesInnerProductsInnerTypeToJSON(value['type']),
        'name': value['name'],
    };
}

